import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addUser, getBranch, getUserRole, getUserStatus, getUserType, getUserTypeCategory, updateUser } from "../../../services/userMasterUser";
import {
  validEmail,
  validateFullName,
  validatePhone,
} from "../../../components/Regex";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";

export default function UserCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [input, setInput] = useState({
    userName: state?.userName || "",
    mobile: state?.mobile || "",
    password: "",
    role: state?.role || "ROLE_EMPLOYEE",
    userTypeId: state?.userTypeId || "",
    branchId: state?.branchId || "",
    mcubeAuthToken: state?.mcubeAuthToken || ""
  });
  const [errors, setErrors] = useState({
    userName: "",
    mobile:"",
    password: "",
    role: "",
    userTypeId: "",
    branchId: "",
    mcubeAuthToken: ""
  });

  const [userStatusData, setUserStatusData] = useState();
  const [userRoleData, setUserRoleData] = useState();
  const [userTypeData, setUserTypeData] = useState([])
  const [branchData, setBranchData] = useState([])

  useEffect(() => {
    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
      setInput(prevState => ({
        ...prevState,
        userTypeId: state.userTypeIds
          ? state.userTypeIds
          : [],
      }));
    }
  }, [state]);

  const fetchServiceAndFrequency = () => {
    getUserStatus()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const services = Res.map((item) => ({
            label: item,
            value: item,
          }));
          setUserStatusData(services);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getUserRole()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const services = Res.map((item) => ({
            label: item.roleName,
            value: item.roleName,
          }));
          setUserRoleData(services);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

   

    const typeData = {
      name: "",
      category: "",
      searchBy: "",
      searchText: ""
    };

    getUserType(typeData)
      .then((response) => {
        if (!response.data.error) {
          const userType = response.data.map((item) => ({
            label: item?.name,
            value: item?.id,
          }));
          setUserTypeData(userType)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));
  };

  const branchDataApi = {
    searchBy: "",
    searchText: "",
    limit: 100000,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: []
  };

  const fetchBranchData = (data) => {
  
      getBranch(data)
        .then((response) => {
          if (!response.data.error) {
            const newData = response.data.data || response.data; // adjust if API structure differs
            const branchDataId = response.data.map((item) => ({
              label: item?.name,
              value: item?.id,
            }));
            setBranchData(branchDataId);
          } else {
            errorMessage("Invalid Credentials");
          }
        })
        .catch(() => {
          errorMessage();
        })
    };

  useEffect(() => {
    fetchBranchData(branchDataApi)
    fetchServiceAndFrequency();
  }, []);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;
    
    if (!validateFullName.test(input.userName)) {
      newErrors.firstName = "Please Enter First Name";
      isValid = false;
    } else {
      newErrors.firstName = "";
    }

    if (!state && !(input.password)) {
      newErrors.password = "Please Enter Password";
      isValid = false;
    } else {
      newErrors.password = "";
    }

    if (input.mobile === "") {
      newErrors.mobile = "Please Enter Mobile Number";
      isValid = false;
    } else {
      newErrors.mobile = "";
    }
   
    if (input.userTypeId === "") {
      newErrors.userTypeId = "Please Select User Type Id";
      isValid = false;
    } else {
      newErrors.userTypeId = "";
    }

    if (input.role === "") {
      newErrors.role = "Please Select Role";
      isValid = false;
    } else {
      newErrors.role = "";
    }

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          ...state,
          id: state.id,
          userName: input.userName,
          mobile: input.mobile,
          password: input.password,
          role: input.role,
          userTypeIds: input.userTypeId,
          branchId: input.branchId,
          mcubeAuthToken: input.mcubeAuthToken,
          status: input.status
        };
        updateUser(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/user/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          userName: input.userName,
          mobile: input.mobile,
          password: input.password,
          role: input.role,
          branchId: input.branchId,
          userTypeIds: input.userTypeId,
          mcubeAuthToken: input.mcubeAuthToken
        };

        addUser(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/user/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/user/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> User {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="userName" className="form-label">
                        Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="userName"
                        name="userName"
                        value={input.userName}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            userName: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.firstName}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="password" className="form-label">
                        Password
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="password"
                        name="password"
                        value={input.password}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            password: e.target.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.password}</div>
                    </div>
                  </div>
                  
                  {/*<div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="workingDays" className="form-label">
                        No. of Working Days
                      </label>
                      <InputNumber
                        inputId="horizontal"
                        value={input.workingDays}
                        id="workingDays"
                        name="workingDays"
                        style={{ width: "100%" }}
                        onValueChange={(e) =>
                          setInput({
                            ...input,
                            workingDays: e.target.value,
                          })
                        }
                        showButtons
                        buttonLayout="horizontal"
                        step={1}
                        decrementButtonClassName="p-button-danger"
                        incrementButtonClassName="p-button-success"
                        incrementButtonIcon="pi pi-plus"
                        decrementButtonIcon="pi pi-minus"
                        mode="decimal"
                        minFractionDigits={0}
                        min={0}
                        required
                      />
                      <div className="text-danger">{errors.workingDays}</div>
                    </div>
                    <div className=" field col-md-6">
                      <label htmlFor="cost" className="form-label">
                        Cost
                      </label>
                      <InputNumber
                        inputId="horizontal"
                        value={input.cost}
                        id="cost"
                        name="cost"
                        style={{ width: "100%" }}
                        onValueChange={(e) =>
                          setInput({
                            ...input,
                            cost: e.target.value,
                          })
                        }
                        showButtons
                        buttonLayout="horizontal"
                        step={1}
                        decrementButtonClassName="p-button-danger"
                        incrementButtonClassName="p-button-success"
                        incrementButtonIcon="pi pi-plus"
                        decrementButtonIcon="pi pi-minus"
                        mode="currency"
                        currency="INR"
                        minFractionDigits={0}
                        min={0}
                        required
                      />
                       
                      <div className="text-danger">{errors.cost}</div>
                    </div>
                  </div>*/}
                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="mobile" className="form-label">
                        Mobile Number
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="mobile"
                        name="mobile"
                        value={input.mobile}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            mobile: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.mobile}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="userTypeId" className="form-label">
                        User Type Id
                      </label>
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={input.userTypeId}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            userTypeId: e.value,
                          });
                        }}
                        options={userTypeData}
                        optionLabel="label"
                        placeholder="Select Product"
                      />
                      <div className="text-danger">{errors.userTypeId}</div>
                    </div>
                   
                      
                     
                  </div>
                  <div className="row mb-1">
                    <div className="col-md-12">
                      <label htmlFor="mcubeAuthToken" className="form-label">
                        MCUBE Auth Token
                      </label>
                      <textarea
                        style={{ width: "100%" }}
                        id="mcubeAuthToken"
                        name="mcubeAuthToken"
                        value={input.mcubeAuthToken}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            mcubeAuthToken: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mb-1">
                    <div className="col-md-6">
                      <label htmlFor="role" className="form-label">
                        Role
                      </label>

                      <Dropdown
                        style={{ width: "100%" }}
                        options={userRoleData}
                        value={input.role}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            role: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.role}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="branchId" className="form-label">
                        Branch Id
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={branchData}
                        value={input.branchId}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            branchId: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.branchId}</div>
                    </div>
                    </div>
                  
                  {state?.id && <div className="row mb-1">
                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={userStatusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>}
                     
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
